import { LanguageIcon } from '@heroicons/react/24/outline';
import { navigate } from 'gatsby';
import React from 'react';
import { Button, Toast as DaisyUIToast, Dropdown } from 'react-daisyui';
import toast from 'react-hot-toast';
import type { ToastProps } from './types';

const Toast = ({ message, options }: ToastProps) => {
    toast.custom((toastNode) => (
        <DaisyUIToast
            className={`${toastNode.visible ? 'animate-enter' : 'animate-leave'}
                    bg-white max-w-md shadow-lg w-full rounded-lg pointer-events-auto flex 
                    ring-1 ring-black ring-opacity-5 relative flex-row p-0`}
        >
            <div className="flex-1 w-0 p-4 ">
                <div className="ml-3 flex items-center justify-center">
                    <div className="w-full">
                        <p className="text-sm font-medium text-gray-900">{message}</p>
                    </div>
                    <div className="flex">
                        <Dropdown className="max-md:dropdown-end">
                            <Button color="ghost" className="btn-circle">
                                <LanguageIcon className="w-5 h-5 text-[#888]" />
                            </Button>
                            <Dropdown.Menu className="w-52">
                                {!!options?.length &&
                                    options.map((option, index) => (
                                        <Dropdown.Item
                                            key={`language-menu-item-${option.lang}-${index}`}
                                            onClick={() => {
                                                navigate(option.url);
                                                toast.dismiss(toastNode.id);
                                            }}
                                        >
                                            <span className="text-gray-800 no-underline">{option.lang}</span>
                                        </Dropdown.Item>
                                    ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </DaisyUIToast>
    ));
};

export default Toast;
